<template>
  <div class="col-12 c g">
    <div class="card card-body">
        <h5>كشوف المتابعة المسندة اليك</h5>
        <div class="g" v-if="!kushof.length">
            <div class="alert alert-warning text-center g">
                <h5>
                    لم يتم تعيين اي كشوف لك.
                </h5>
            </div>
        </div>
        <div class="col-12 table-responsive" v-if="kushof.length">
            <table class="table table-hover table-bordered table-sm">
                <thead>
                    <th>
                        المادة
                    </th>
                    <th>
                        الفصل
                    </th>
                    <th>
                        تاريخ الإسناد
                    </th>
                    <th>
                        خيارات
                    </th>
                </thead>
                <tbody>
                    <tr v-for="h in kushof" :key="h._id">
                        <td>
                            {{ h.subject }}
                        </td>
                        <td>
                            {{ h.classroom.replace(",", " - ") }}
                        </td>
                        <td>
                            {{ h.date.split(" ")[0] }}
                        </td>
                        <td>
                            <button class="btn btn-sm btn-primary" @click="view(h)">
                                <i class="fa fa-file"></i>
                                عرض
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BFormCheckbox,
    },
    directives: {
        Ripple,
    },
    data(){
        return {
            teacher: JSON.parse(localStorage.getItem('teacher')),
            kushof: []
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
      gett(){
        var g = this;
        $.post(api + '/teacher/kushof', {
            username: this.teacher.username,
            password: this.teacher.password
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.kushof = r.response;
            }
        }).fail(function(){
        })
      },
        view(h){
            var g = this;
            var newWin= window.open("");
            if(h.content){
              newWin.document.write(h.content + `<style>
form{
  display: none;
}</style>`)
              newWin.document.designMode = 'on'
              newWin.addEventListener("unload", () => {
                  g.gett()
              })
              return;
            }
            var trbiafniaapk = `<tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="2">المهام الأدائية</th>
    <th colspan="2">المشاركة والتفاعل</th>
    <th colspan="2">الاختبار</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>واجبات</th>
    <th>بحوث مشروعات</th>
    <th>تطبيقات انشطة صفية</th>
    <th>مشاركة</th>
    <th>قصير</th>
    <th>تطبيقي</th>
 </tr>
 <tr style="background:#ddd">
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;

        var trbiafniafady = ` <td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;

        var rqmiardtr = ` <tr style="background:#ddd">
    <th rowspan="2" colspan="2">اسم الطالب</th>
    <th>واجبات</th>
    <th>بحوث مشاريع</th>
    <th>أنشطة ومشاركة</th>
    <th>تطبيقات عملية</th>
    <th>اختبار قصير</th>
    <th>المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;

        var rqmiafady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;

        var drasaatrowstop = ` <tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="2">المهام الأدائية</th>
    <th colspan="2">المشاركة والتفاعل</th>
    <th colspan="2">الاختبار</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>واجبات</th>
    <th>بحوث مشروعات</th>
    <th>تطبيقات انشطة صفية</th>
    <th>مشاركة</th>
    <th>قصير</th>
    <th>نهائي</th>
 </tr>
 <tr style="background:#ddd">
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
        var drasaatrowstopfady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
        var osriarowst = `<tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="2">المهام الأدائية</th>
    <th colspan="2">المشاركة والتفاعل</th>
    <th colspan="2">الاختبار</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>واجبات</th>
    <th>بحوث مشروعات</th>
    <th>تطبيقات انشطة صفية</th>
    <th>مشاركة</th>
    <th>قصير</th>
    <th>نهائي</th>
 </tr>
 <tr style="background:#ddd">
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>--</th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
        var osriarowstfady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
        var loomtoptr = ` <tr style="background:#ddd">
    <th rowspan="2" colspan="2">اسم الطالب</th>
    <th>واجبات</th>
    <th>مهام أدائية</th>
    <th>مشاركة</th>
    <th>اختبار قصير</th>
    <th>اختبار نهائي</th>
    <th>المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
        var loomtoptrfady = ` <td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
        var nafstoptr = ` <tr style="background:#ddd">
    <th rowspan="2" colspan="2">اسم الطالب</th>
    <th>واجبات</th>
    <th>مهام أدائية</th>
    <th>مشاركة</th>
    <th>اختبار قصير</th>
    <th>اختبار نهائي</th>
    <th>المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
        var nafstoptrfady = ` <td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
        var wcantoptrs = ` <tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="2">المهام الأدائية</th>
    <th colspan="2">المشاركة والتفاعل</th>
    <th colspan="2">الاختبار</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>واجبات</th>
    <th>بحوث مشروعات</th>
    <th>تطبيقات انشطة صفية</th>
    <th>مشاركة</th>
    <th>قصير</th>
    <th>تطبيقي</th>
 </tr>
 <tr style="background:#ddd">
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
       var  wcantoptrsfady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
       var  tagwidtoptrd = ` <tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="4">القرآن الكريم</th>
    <th colspan="4">التجويد</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>صحة القراءة</th>
    <th>الترتيل</th>
    <th>التجويد</th>
    <th>الحفظ</th>
    <th>واجبات</th>
    <th>تطبيقات</th>
    <th>اختبار قصير</th>
    <th>اختبار نهائي</th>
 </tr>
 <tr style="background:#ddd">
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 10);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 11);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
      var   tagwidtoptrdfady = ` <td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
       var  islamiatoptrs = `<tr style="background:#ddd">
    <th rowspan="2" colspan="2">اسم الطالب</th>
    <th>واجبات</th>
    <th>مهام أدائية</th>
    <th>مشاركة</th>
    <th>اختبار قصير</th>
    <th>اختبار نهائي</th>
    <th>المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
       var  islamiatoptrsfady = ` <td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
      var   ryadiattoptrs = ` <tr style="background:#ddd">
    <th rowspan="2" colspan="2">اسم الطالب</th>
    <th>واجبات</th>
    <th>مهام أدائية</th>
    <th>مشاركة</th>
    <th>اختبار قصير</th>
    <th>اختبار نهائي</th>
    <th>المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
      var   ryadiattoptrsfady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
       var  gmilatoptrf = ` <tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="2">المهام الأدائية</th>
    <th colspan="2">المشاركة والتفاعل</th>
    <th colspan="2">الاختبار</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>واجبات</th>
    <th>بحوث مشروعات</th>
    <th>تطبيقات انشطة صفية</th>
    <th>مشاركة</th>
    <th>قصير</th>
    <th>نهائي</th>
 </tr>
 <tr style="background:#ddd">
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
     var   gmilatoptrffady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
     var    lo8atytoptrs = ` <tr style="background:#ddd">
    <th rowspan="3" colspan="2">اسم الطالب</th>
    <th colspan="2">المهام الأدائية</th>
    <th colspan="2">المشاركة والتفاعل</th>
    <th colspan="2">الاختبار</th>
    <th rowspan="2">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>واجبات</th>
    <th>بحوث مشروعات</th>
    <th>تطبيقات انشطة صفية</th>
    <th>مشاركة</th>
    <th>قصير</th>
    <th>نهائي</th>
 </tr>
 <tr style="background:#ddd">
    <th>5<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>15<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>20<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>40<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 8);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 9);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
       var  lo8atytoptrsfady = `  <td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
       var  krimtoptrs = ` <tr style="background:#ddd">
    <th rowspan="2" colspan="2">اسم الطالب</th>
    <th style="width:12%">صحة القراءة</th>
    <th style="width:12%">الترتيل</th>
    <th style="width:12%">تطبيق التجويد</th>
    <th style="width:12%">الحفظ</th>
    <th style="width:12%">المجموع</th>
 </tr>
 <tr style="background:#ddd">
    <th>45<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 3);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 4);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>10<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 5);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>35<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 6);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
    <th>100<button onclick="function insertNumberIntoNthChildTd(tableId, nthChildPosition, startNumber = 1) {
  const table = document.getElementById(tableId);
    var p = prompt('كم الدرجة التي تريد تعيينها للجميع؟')
  // Check if the table exists
  if (!table) {
    console.error('Table with ID tableId not found.');
    return;
  }

  const tbody = table.querySelector('tbody');
  const rows = tbody.querySelectorAll('tr');
  rows.forEach(row => {
    const targetTd = row.querySelector('td:nth-child('+nthChildPosition+')');
    if (targetTd) {
      targetTd.textContent = p;
    }
  });
}
  insertNumberIntoNthChildTd('myTable', 7);
" style='font-size: 14px; padding: 2px; width: 30px;'>الكل</button></th>
 </tr>`;
      var   krimtoptrsfady = `<td></td>
<td></td>
<td></td>
<td></td>
<td></td>`;
    var trfady = "", trfortoprows = "";
        var subject = h.subject
        if (subject.indexOf("فنية") !== -1) {
            trfady = trbiafniafady;
            trfortoprows = trbiafniaapk;
        } else if (subject.indexOf("رقمية") !== -1) {
            trfady = rqmiafady;
            trfortoprows = rqmiardtr;
        } else if (subject.indexOf("جتماعية") !== -1) {
            trfady = drasaatrowstopfady;
            trfortoprows = drasaatrowstop;
        } else if (subject.indexOf("سرية") !== -1) {
            trfady = osriarowstfady;
            trfortoprows = osriarowst;
        } else if (subject.indexOf("علوم") !== -1) {
            trfady = loomtoptrfady;
            trfortoprows = loomtoptr;
        } else if (subject.indexOf("نفس") !== -1) {
            trfady = nafstoptrfady;
            trfortoprows = nafstoptr;
        } else if ((subject.indexOf("We") !== -1) || (subject.indexOf("WE") !== -1) || (subject.indexOf("we") !== -1)) {
            trfady = wcantoptrsfady;
            trfortoprows = wcantoptrs;
        } else if (subject.indexOf("تجويد") !== -1) {
            trfady = tagwidtoptrdfady;
            trfortoprows = tagwidtoptrd;
        } else if (subject.indexOf("سلام") !== -1) {
            trfady = islamiatoptrsfady;
            trfortoprows = islamiatoptrs;
        } else if (subject.indexOf("رياض") !== -1) {
            trfady = ryadiattoptrsfady;
            trfortoprows = ryadiattoptrs;
        } else if (subject.indexOf("جميلة") !== -1) {
            trfady = gmilatoptrffady;
            trfortoprows = gmilatoptrf;
        } else if ((subject.indexOf('لغتي') !== -1) && (subject.indexOf('الجميلة') == -1)) {
            trfady = lo8atytoptrsfady;
            trfortoprows = lo8atytoptrs;
        } else if ((subject.indexOf('الكريم') !== -1) && (subject.indexOf('وتجويده') == -1)) {
            trfady = krimtoptrsfady;
            trfortoprows = krimtoptrs;
        } else {
            trfady = ryadiattoptrsfady;
            trfortoprows = ryadiattoptrs;
        }
        var data = "";
        var index = 0;
        h.students.forEach(function(a){
            index = index + 1
            data = data + `<tr style="background:#fff; text-align: right">
                    <td>${index}</td> <td  style="  border-top: 1px black solid;">${a.name}</td>
                    ${trfady}
                </tr>`
        })
            newWin.document.designMode = 'on'
            newWin.document.write(`
            <!DOCTYPE html>
<html lang="ar" dir="rtl">

<head>
    <meta charset="UTF-8">
    <link rel="icon" href="/assets/custom/img/logo.png" type="image/png">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>
        التحضير الذكي | www.tahdir.net
    </title>
    <style>
form{
  display: none;
}
        @font-face {
            font-family: 'myFirstFont';
            src: url("/calibril.ttf");
        }

        table,
        td,
        th {
            border: 1px solid;
            padding: 1px !important
        }

        table {
            width: 100%;
            border-collapse: collapse;
        }

        * {
            font-family: "myFirstFont" !important;
            font-weight: normal !important;
            white-space: nowrap;
        }

        .content {
            position: relative;
            top: -120px;
            width: 90%;
            margin: 0px auto;
        }

        .copy {
            position: absolute;
            z-index: 999;
            top: 0px;
            left: 0px;
        }

        button {
            border: 2px solid #4CAF50;
            /* Green */
            padding: 0px;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 20px;
            margin: 4px 2px;
            transition-duration: 0.4s;
            cursor: pointer;
            width: 100px;
            background-color: #4CAF50;
            color: white;
        }
        .print {
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 9999 !important;
        }
        .forward button {
            position: absolute;
            top: 0px;
            left: 120px;
            width: 120px;
            background: #799EFF !important;
            z-index: 9999 !important;
        }
        .save button {
            position: absolute;
            top: 0px;
            left: 250px;
            width: 120px;
            background: #00809D !important;
            z-index: 9999 !important;
        }


        button:hover {
            background-color: #ff05c9;
            /* Green */
            color: white;
        }

        .content img {
            position: absolute;
            top: 0px;
            max-height: 80vh
        }

        @media  print {
            .print {
                display: none
            }
            button {
                display: none
            }
        }

        @page  {
            margin: 0px;
            padding: 0px
        }
    </style>
</head>

<body>
    <div class="print" onclick="window.print()">
        <button>طباعة الآن</button>
    </div>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js"><`+`/script>
    <div class="forward" onclick="
    $('form').remove()
    $('body').append(\`
    <form action='${api}/teacher/send-kushof' method='post' target='_blank'  style='display:nonex'>
        <input value='${g.teacher.username}' name='username'>
        <input value='${g.teacher.password}' name='password'>
        <input value='${h._id}' name='id'>
        <textarea name='content' class='contentx'></textarea>
        <textarea name='content2' class='contentx2'></textarea>
        <button id='cdcd'></button>
    </form>
    \`)
    
    $('.contentx').val($('body').html())
    $('.contentx2').val('<html dir=rtl>'+$('html').html()+'</html>')
    setTimeout(function(){
      $('#cdcd').click()
    }, 500)
    setTimeout(function(){
    alert('تم الارسال بنجاح')
    }, 1500)
    ">
        <button>إرسال للمدرسة</button>
    </div>
    <div class="save" onclick="
    $('form').remove()
    $('body').append(\`
    <form action='${api}/teacher/save-kushof' method='post' target='_blank' style='display:nonex'>
        <input value='${g.teacher.username}' name='username'>
        <input value='${g.teacher.password}' name='password'>
        <input value='${h._id}' name='id'>
        <textarea name='content' class='contentx'></textarea>
        <button id='cdcd'></button>
    </form>
    \`)
    $('.contentx').val('<html dir=rtl>'+$('html').html()+'</html>')
    setTimeout(function(){
      $('#cdcd').click()
    }, 500)
    setTimeout(function(){
    alert('تم الارسال بنجاح')
    }, 1500)
    ">
        <button>حفظ الكشف</button>
    </div>
    <header style="position: relative;top:-110px">
        <div style='width: 100%; padding: 20px;'>
            <div style='width: 30%; text-align: center; display: inline-block; position: relative;top:-20px !important'>
                <h4>
                    <img src="https://cdn-static.brmja.com/storage/scrapped/6319866ea8712498504411.jpg"
                        style='width: 50%' alt="">
                    <br>
                    ${window.ministry_name}
                    <br>
                    <div id="school_name">${h.school_name}</div>
                    </h5>
            </div>
            <div style='width: 30%; text-align: center; display: inline-block; position: relative; top: 5px'>
                <br><br><br><br>
                <img src='${window.ministry_logo}' style='width: 80%'>
            </div>
            <div
                style='width: 30%; text-align: center; display: inline-block; position: relative; top: 0px !important; text-align: right'>
                <h3>
                    العام الدراسي: &nbsp;&nbsp; / &nbsp;&nbsp; / &nbsp;144<br>
                    الفصل الدراسي: ${h.semster}<br>
                    الفصل: ${h.classroom.replace(',', ' - ')}<br>
                    المادة: ${h.subject}
                </h3>
            </div>
        </div>
    </header>
    <div class="content">
        <center>
            <div id="title"></div>
        </center>
        <br>
        <table id='myTable'>
            <tbody>${trfortoprows}${data}</tbody>
        </table>
        <h4>
            <span id="teacher">معلم المادة: 
                ${h.teacher_name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> مدير المدرسة: ${h.school_admin}
            <span></span> <br><small style="float:left">
             
        </h4>
    </div>
    <script`+`>document.designMode = 'on'<`+`/script>
    </body></html>
            `);
            newWin.document.close()
            newWin.document.designMode = 'on'
            newWin.addEventListener("unload", () => {
                g.gett()
            })
        }
    }
}
</script>

<style>
.classroom{
    padding: 15px; 
    border: 2px solid #ddd;
    border-radius: 5px;
}
.classroom:hover{
    background: #fafafa !important;
    cursor: pointer;
    border: 2px solid #333;
}
</style>